export default __webpack_public_path__ + "static/media/techokids.6b49947d.jfif";